import { parseISO } from 'date-fns';

/**
 * Converts a date and time to UTC ISO string
 * @param date - Date object or ISO date string
 * @param startTime - Time string or Date object
 * @returns UTC ISO string or null if inputs are invalid
 */

const convertToUTC = (date: string | Date, startTime: string | Date): string | null => {
  if (!date || !startTime) return null;

  const visitDate = typeof date === 'string' ? parseISO(date) : date;

  const timeDate = new Date(startTime);

  if (Number.isNaN(visitDate.getTime()) || Number.isNaN(timeDate.getTime())) {
    return null;
  }

  // Create a new date with the selected date and time
  // This automatically handles the user's timezone
  const localDateTime = new Date(
    visitDate.getFullYear(),
    visitDate.getMonth(),
    visitDate.getDate(),
    timeDate.getHours(),
    timeDate.getMinutes(),
    timeDate.getSeconds(),
    timeDate.getMilliseconds(),
  );

  return localDateTime.toISOString();
};

export default convertToUTC;
